import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CartProduct } from "../../components/CartProduct";
import { getCartProductQuantity } from "../../store/cart";
import { openProductModal } from "../../store/product";
import { productImageThumbnailPath } from "../../utils/product.util";
import { getCurrencySign } from "../../store/common";

const CartItemContainer = ({
  cartProduct,
  productCartQuantity,
  deleteCartProduct,
  orderType,
  openProductModal,
  currencySign
}) => (
  <div className="cartBar__item">
    <div className="d-flex flex-column">
      <div className="cartBar__item__body__name">{cartProduct.code}</div>
      <div className="d-flex justify-content-between">
        <div className="cartBar__item__image">
          <div>
            <img
              src={productImageThumbnailPath(cartProduct.image, cartProduct.id, cartProduct.imageType)}
              alt={cartProduct.code}
              className="img-responsive"
              onClick={() => openProductModal(cartProduct.id)}
            />
          </div>
        </div>
        <CartProduct
          key={cartProduct.id}
          cartProduct={cartProduct}
          productCartQuantity={productCartQuantity}
          deleteCartProduct={deleteCartProduct}
          orderType={orderType}
          currencySign={currencySign}
        />
      </div>
    </div>
  </div>
);

CartItemContainer.propTypes = {
  cartProduct: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      ean: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      quantity: PropTypes.number.isRequired
    })
  ).isRequired,
  deleteCartProduct: PropTypes.func.isRequired,
  productCartQuantity: PropTypes.number,
  orderType: PropTypes.string,
  currencySign: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  productCartQuantity: getCartProductQuantity(
    state.cart,
    ownProps.cartProduct.id
  ),
  orderType: state.customer.actionOnCustomer,
  currencySign: getCurrencySign(state.common.user.currency.sign)
});

const mapDispatchToProps = dispatch => ({
  openProductModal: id => dispatch(openProductModal(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartItemContainer);



// WEBPACK FOOTER //
// ./src/containers/Cart/CartItemContainer.js